import {useParams, useRouteMatch} from 'react-router-dom';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';
import {ActivityTimeline} from '../../../../../../../components/activity-timeline/activity-timeline';
import {ScreenPaths} from '../../../../../../../enums';
import {translations} from '../../../../../../../i18n/translations';
import {useSeniorSidebar} from '../../../../../../../contexts/seniors-sidebar/context';

export default function SeniorActivityProfessionalCaregiverOfficeScreen() {
  let {id, entityId}: {id: string; entityId: string} = useParams();
  let {url} = useRouteMatch();
  const {t} = useTranslation();
  const seniorCtx = useSeniorSidebar();

  const seniorName =
    seniorCtx.state.senior?.originalData.displayName ??
    seniorCtx.state.senior?.originalData.name ??
    '';

  return (
    <Box className="senior-profile-wrapper">
      <ActivityTimeline
        headerTitleCrumbs={[
          {
            label: t(translations.screen_paths.professional_caregiver_seniors),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}`,
          },
          {
            label: seniorName,
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_PersonalData}${ScreenPaths.Senior_Profile}`,
          },
          {
            label: t(translations.screen_paths.senior_dashboard),
            link: `${ScreenPaths.Office}${ScreenPaths.Office_ProfessionalCaregiver}/${entityId}${ScreenPaths.ProfessionalCaregiver_Seniors}/${id}${ScreenPaths.Senior_Dashboard}`,
          },
          {
            label: t(translations.screen_paths.senior_activity),
            link: url,
          },
        ]}
        caregiverMode={CaregiverMode.Professional}
        entityId={entityId}
        participantUserId={id}
      />
    </Box>
  );
}
